import React from 'react';

const ThankYouScreen = ({ answers = [] }) => {
  // Check if patient selected insurance (not self-pay)
  const hasInsurance = answers.some(answer =>
    answer && typeof answer === 'object' && answer.type === 'insurance'
  );

  const handlePatientPortal = () => {
    // Navigate to patient portal
    // Replace with actual URL
    window.location.href = process.env.REACT_APP_PORTAL_URL;
  };

  const handleTextUs = () => {
    // Navigate to text/SMS page
    // Replace with actual URL or phone number
    window.location.href = 'sms:+17816504492';
  };

  return (
    <div className="thank-you-screen">
      <div className="thank-you-content">
        <div className="thank-you-header">
          <div className="checkmark-icon">✓</div>
          <h2>Thank You!</h2>
          <p className="subtitle">Your information has been securely submitted.</p>
        </div>

        <div className="step-card">
          <h3>
            <span className="material-symbols-outlined">medical_information</span>
            Dermatologist Review
          </h3>
          <p>
            A board-certified dermatologist will review your information
            and photos to develop your personalized treatment plan.
          </p>
        </div>
        {hasInsurance && (
          <div className="step-card">
            <h3>
              <span className="material-symbols-outlined">video_chat</span>
              Video visit
            </h3>
            <p>
              Next, you'll have a dedicated 15-minute video call with one of our expert nurse practitioners.
              During this visit, they will review your personalized treatment plan in detail and answer your questions.
            </p>
          </div>
        )}

        <div className="action-buttons">
          <button
            className="primary-action-button"
            onClick={handlePatientPortal}
          >
            Patient Portal
          </button>
          <button
            className="secondary-action-button"
            onClick={handleTextUs}
          >
            Text Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouScreen;

